import {ChevronLeft} from "lucide-react"
import Link from "next/link"

import {iconButtonClassName} from "./icon-button"

/**
 * "Back to <where>" — the round beta2 back control with its destination named
 * beside it, so every sub-page leaves the same way and says where to.
 */
export const BackLink = ({href, label}: {href: string; label: string}) => (
  <Link
    href={href}
    className="group inline-flex w-fit items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
  >
    <span aria-hidden className={iconButtonClassName}>
      <ChevronLeft className="size-5" />
    </span>
    {label}
  </Link>
)
